export var defaultState = {
    languagePopup: {
        isVisible: false,
    },
};
